import React from 'react';
import { data_z_dniem } from '../../../../functions/dataFormat';

const ZbiorowyKomornikNadawca = () => {

    return (
        <section
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '12px'
            }}
        >
            <div>
                <span
                    style={{
                        fontWeight: "600",
                        textDecoration: "undetline",
                        lineHeight: "1.5rem"
                    }}
                >
                    Administrator
                </span><br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            </div>
            <div>
                <span>{`Gorzów Wlkp. ${data_z_dniem()}`}</span>
            </div>
        </section>            
    )
}

export default ZbiorowyKomornikNadawca;